import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RedirectComponent } from './public/redirect/redirect.component';
import { AppInitService } from '@core/services/app-init.service';

const routes: Routes = [
  {
    path: 'pages',
    loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
  },
  {
    path: 'auth',
    loadChildren: () =>
      AppInitService.initGeoInitList()
        .then(() => import('./pages/auth/auth.module'))
        .then((m) => m.AuthModule),
  },
  {
    path: '',
    redirectTo: 'pages',
    pathMatch: 'full',
  },
  {
    path: 'store/:storeId',
    component: RedirectComponent,
  },
  {
    path: 'company/:companyId',
    component: RedirectComponent,
  },
  {
    path: '**',
    redirectTo: 'pages',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
